import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const documentType = {
  path: "/paymentBonus",
  component: Layout,
  name: "paymentBonus",
  redirect: "/paymentBonus/index",
  children: [
    {
      path: "/paymentBonus/index",
      component: () => import("@/views/paymentBonus/index"),
      name: "paymentBonus.index",
      meta: { title: i18n.t(`message.paymentBonusP`) },
    },
  ],
};

export default documentType;
